import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-slate-800 bg-slate-900/50 py-4 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-slate-500">
        <span>&copy; {new Date().getFullYear()} BookMyBand</span>
        <nav className="flex gap-5">
          <Link to="/faq" className="hover:text-slate-300 transition-colors">FAQ</Link>
          <Link to="/contact" className="hover:text-slate-300 transition-colors">Contact</Link>
          <Link to="/terms" className="hover:text-slate-300 transition-colors">Terms &amp; Conditions</Link>
        </nav>
      </div>
    </footer>
  );
}
